<template>
    <div id="Purchase_order">
        <!-- form -->
        <el-card class="table_searchbar">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="5">
                    <div @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">采购单号：</span>
                        <el-input :style="W?{'max-width':'160px'}:{'max-width':'140px'}" size="small" v-model="searchForm.purchaseCode" maxlength="100" placeholder="采购单号"></el-input>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">物料编码：</span>
                        <el-select filterable @visible-change="selectBlur" v-model="searchForm.materialId" :loading="loading"  :remote-method="query=>remoteMethod(query)" remote placeholder="物料编码" style="width:200px" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-option v-for="item in materiaList" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">物料名称：</span>
                        <el-select filterable @visible-change="selectBlur" v-model="searchForm.materialId" :loading="loading" :remote-method="query=>remoteMethod('',query)" remote placeholder="物料名称" style="width:200px" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-option v-for="item in materiaList" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div @keydown.enter="clickSearch(1,'setpage')">
                        <span class="title">采购类型：</span>
                        <el-select :style="W?{'max-width':'180px'}:{'max-width':'140px'}" clearable v-model="searchForm.PurchaseType" size="small" maxlength="16"  placeholder="采购类型">
                            <el-option v-for="item in purchaseOptions" :key="item.id" :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4" style="text-align:right">
                    <el-button icon="el-icon-search" size="mini" type="primary" @click="clickSearch(1,'setpage')">查询</el-button>
                    <el-button style="margin-left: 9px;" icon="el-icon-refresh" size="mini" @click="clearSearch">重置</el-button>
                </el-col>
            </el-row>
        </el-card>
        <!-- button -->
        <el-card class="table-card">
            <el-row>
                <div >
                    <el-col :span="24">
                        <el-button type="primary" @click="addOrder" v-if="permission.btn_purchase_addPurchase">新增采购单</el-button>
                        <el-upload class="import_upload" accept=".xls, .xlsx" :show-file-list="false" :action="uploadUrl()" :before-upload="beforeLoad" :on-success="uploadComplete">
                            <el-button type="primary" size="small" v-if="permission. btn_purchase_importPurchase ">导入采购单</el-button>
                        </el-upload>
                        <div class="import_upload" style="margin-left:9px;margin-right:9px">
                            <a class="import_upload" href="/api/purchase/downloadTheTemplate">
                                <el-button size="small">
                                    模板下载
                                    <i class="el-icon-download el-icon--right"></i>
                                </el-button>
                            </a>
                        </div>
                    </el-col>
                </div>
            </el-row>
            <!-- tab -->
            <el-row class="tab" >
                <el-row>
                    <div style="margin-top:20px;">
                        <el-table :data="purchaseList" class="table_data y_Public_table" style="width:100%">
                            <el-table-column prop="purchaseCode" label="采购单号" min-width="110" max-width="120"></el-table-column>
                            <el-table-column prop="purchaseType" label="采购类型" min-width="80" max-width="120">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.purchaseType==0">订单采购</span>
                                    <span v-if="scope.row.purchaseType==1">库存采购</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialName" label="物料名称" min-width="95" max-width="120"></el-table-column>
                            <el-table-column prop="materialCode" label="物料编码" min-width="135" max-width="170"></el-table-column>
                            <el-table-column prop="demandAmount" label="需求数量" min-width="70" max-width="90"></el-table-column>
                            <el-table-column prop="planPurchaseTime" label="预计到厂时间" min-width="95" max-width="120"></el-table-column>
                            <el-table-column prop="purchaseStatus" label="状态" show-overflow-tooltip min-width="70" max-width="90" :formatter="parseStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.purchaseStatus!=2" :style="scope.row.purchaseStatus==0?{color:'red'}:{}">{{parseStatus(scope.row)}}</span>
                                    <span v-else style="color:green">{{parseStatus(scope.row)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="gmtCreate" label="创建时间" min-width="135" max-width="170"></el-table-column>
                            <el-table-column prop="gmtModified" label="更新时间" min-width="135" max-width="170"></el-table-column>
                            <el-table-column prop="verifierName" label="审核人" min-width="70" max-width="100"></el-table-column>
                            <el-table-column label="操作" min-width="220" max-width="260" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="editBtn(scope.row)" v-if="scope.row.purchaseStatus==0&&permission.btn_purchase_updatePurchase">编辑</el-button>
                                    <el-button type="text" size="small" @click="dispose(scope.row,scope.row.purchaseStatus)" v-if="scope.row.purchaseStatus==0">审核</el-button>
                                    <el-button type="text" size="small" @click="dispose1(scope.row,scope.row.purchaseStatus)" v-if="scope.row.purchaseStatus==1">反审核</el-button>
                                    <el-button type="text" size="small" @click="dispose2(scope.row,3)" v-if="scope.row.purchaseStatus==0||scope.row.purchaseStatus==1">取消</el-button>
                                    <el-button type="text" size="small" @click="printList(scope.row)" >打印</el-button>
                                    <el-button type="text" size="small" @click="dispose3(scope.row,2)" v-if="scope.row.purchaseStatus==1">完成</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-row>
            <!-- 分页 -->
                <div class="page" v-if="page.isShow" style="margin-right:20px">
                    <div class="total_page">
                        <span>共{{page.total}}条 10条/页</span>
                    </div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                        <el-pagination background layout="prev, pager, next" :total="page.total" @current-change="pageChange" :current-page="page.tableCurrentPage"></el-pagination>
                    </div>
                </div>
            </el-row>
        </el-card>

        <!-- 操作编辑对话框开始 -->
        <el-dialog title="编辑任务" :visible.sync="editDialogVisible" center :close-on-click-modal="false" :width="W?'50%':'60%'">
            <!-- :rules="rules" ref="editForm" class="addForm" -->
            <el-form :model="editAddForm" :rules="rules" ref="editForm">
                <el-row :gutter="20" style="margin-bottom:50px">
                    <el-col :span="8">
                        <div class>
                            <span class="title">采购订单：</span>
                            <el-input  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}" v-model="editAddForm.purchaseCode" :disabled="true"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="title">采购类型：</span>
                            <!-- <el-form-item style="display:inline-block" prop=""><el-input :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}" v-model="editAddForm.type"></el-input></el-form-item> -->
                            <el-select :disabled="true" v-model="editAddForm.purchaseType" remote placeholder="请选择" style="width:200px" clearable @change="changeType" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                <el-option v-for="item in purchaseOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="title">物料名称：</span>
                            <!-- <el-input style="width:180px" v-model="editAddForm.name"></el-input> -->
                            <el-form-item style="display:inline-block" prop>
                                <el-input disabled v-model="editAddForm.materialName" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:50px">
                    <el-col :span="8">
                        <div class>
                            <span class="title">物料编码：</span>
                            <!-- <el-input style="width:180px" v-model="editAddForm.code"></el-input> -->
                            <el-form-item style="display:inline-block" prop>
                                <el-input disabled v-model="editAddForm.materialCode" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="title">需求数量：</span>
                            <!-- <el-input style="width:180px" v-model="editAddForm.num"></el-input> -->
                            <el-form-item style="display:inline-block" prop="demandAmount">
                                <el-input :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}" v-model="editAddForm.demandAmount"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="title" style="marginLeft: -30px">预计到厂时间：</span>
                            <!-- <el-input style="width:180px" v-model="editAddForm.emtime"></el-input> -->
                            <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期" style="width:180px"></el-date-picker> -->
                            <el-date-picker v-model="editAddForm.planPurchaseTime" type="date" @change="check($event,1)" placeholder="选择日期" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-date-picker>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <div class>
                            <span class="demonstration" >供应商：</span>
                            <el-form-item style="display:inline-block">
                                <el-input size="small" maxlength="16" placeholder="供应商" v-model="editAddForm.supplier" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddDialog">确 定</el-button>
                <el-button @click="cancelEdit">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 操作编辑对话框结束 -->

        <!-- 新增采购单开始 -->
        <el-dialog title="新增采购单" :visible.sync="addDialogVisible" :width="W?'50%':'60%'" center @close="resetForm()" :close-on-click-modal="false">
            <el-form class="addForm" :rules="rules" :model="addForm" ref="addForm">
                <el-row :gutter="20" style="margin-bottom:30px">
                    <el-col :span="8">
                        <div class>
                            <span>采购类型：</span>
                            <el-form-item style="display:inline-block" filterable>
                                <!-- <el-input ref size="small" maxlength="16" placeholder="采购类型"></el-input> -->
                                <el-select :disabled="true" v-model="addForm.purchaseType" remote placeholder="请选择" style="width:200px" clearable @change="changeType" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                    <el-option v-for="item in purchaseOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span>物料名称：</span>
                            <el-form-item style="display:inline-block">
                                <!-- <el-input ref size="small" maxlength="16" placeholder="物料名称"></el-input> -->
                                <el-select  filterable v-model="addForm.materialId" @change="materSelect($event)"  :loading="loading"  :remote-method="query=>remoteMethod('',query)" remote placeholder="请选择" style="width:200px" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                    <el-option v-for="item in materiaList" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span>物料编码：</span>
                            <el-form-item style="display:inline-block">
                                <el-select filterable v-model="addForm.materialId" @change="materSelect($event)" :loading="loading"  :remote-method="query=>remoteMethod(query)" remote placeholder="请选择" style="width:200px" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                    <el-option v-for="item in materiaList" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:30px">
                    <el-col :span="8">
                        <div>
                            <span>需求数量：</span>
                            <el-form-item style="display:inline-block" prop="demandAmount">
                                <el-input size="small" maxlength="16" placeholder="需求数量" v-model="addForm.demandAmount" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="demonstration" style="marginLeft:-30px">预计到厂时间：</span>
                            <el-form-item style="display:inline-block">
                                <el-date-picker v-model="addForm.planPurchaseTime" type="date" placeholder="选择日期" @change="check($event,1)" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class>
                            <span class="demonstration" >供应商：</span>
                            <el-form-item style="display:inline-block">
                                <el-input size="small" maxlength="16" placeholder="供应商" v-model="addForm.supplier" clearable :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
            </el-form>
            <span slot="footer" style="margin-top:-10px">
                <el-button @click="addOrdrList" type="primary">添 加</el-button>
                <el-button @click="cancelAdd">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 新增采购单结束 -->

        <!-- 批量导入提示框开始 -->
        <el-dialog title="导入详情" style="z-index:99999999999" :close-on-click-modal="false" :visible.sync="exportDialogVisible" :width="(W?'25%':'30%')" center>
            <div class="exprot_info" style="text-align: center">
                <el-row :gutter="20">
                    <span>总共导入设备条数：</span>
                    <span>{{exportInfo.total}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入物料成功条数：</span>
                    <span>{{exportInfo.success}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入物料失败条数：</span>
                    <span>{{exportInfo.fail}}条</span>
                </el-row>
            </div>
            <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
                    <el-button type="primary">下载失败数据</el-button>
                </a>
                <el-button type="primary" style="margin-left:10px" @click="()=>{this.exportDialogVisible = false}">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量导入提示框结束 -->
    </div>
</template>

<script>
import CommonUtils from '../../util/CommonUtils';
export default {
    name:'PurchaseCenter',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value !== '') {
                if (value > 0) {
                    if ((/^([-+]?\d{1,10})(\.\d{1,5})?$/).test(value) === false) {
                        callback(new Error('请输入正确的数量'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error("请输入正确的数量"))
                }
            } else {
                callback(new Error("请输入正确的数量"))
            }
        };
        return {
            loading:false,
            // 搜索表单数据
            searchForm: {
                // workCode: "",
                purchaseCode: "",
                materialId:null,
                PurchaseType: null,
                public: ''
            },
            purchaseOptions: [
                { id: 0, name: "订单采购" },
                { id: 1, name: "库存采购" }
            ],
            W: false,
            //   初始化的采购列表
            purchaseList: [],
            page: {
                isShow: true,
                total: 0,
                // 当前页码
                currentPage: 1,
                // 页/条
                pageSize: 10
            },
            // nowTime: ""
            // 时间
            value1: "2020-06-05",
            // 状态选择
            optionsStatus: [
                { status: 0, label: "已审核" },
                { status: 1, label: "未审核" },
                { status: 2, label: "已完成" },
                { status: 3, label: "已取消" }
            ],
            // 编辑状态
            selectStatus: 0,
            // 编辑对话框
            editDialogVisible: false,
            editAddForm: {
                purchaseCode: "",
                demandAmount: 0,
                materialCode: "",
                materialId: "",
                materialName: "",
                purchaseType: 0,
                planPurchaseTime: ""
            },
            // 新增采购单dialog开关
            addDialogVisible: false,
            // 新增采购form
            // addForm:{},
            addForm: {
                // 订单号
                timenum: "",
                // cs
                product: null,
                purchaseOrder: "",
                // 采购类型
                purchaseType: "",
                // 物料名称-联动
                materialName: "",
                // 物料编码
                materialCode: "",
                // 物料id
                materialId: "",
                // 预计到场时间
                planPurchaseTime: "",
                // 需求数量
                demandAmount: "",
                public: "",
                supplier:''
            },
            purchaseType: "",
            ref: [],
            // ceshi
            deviceList: [],
            materiaList: [],
            rules: {
                // timenum: [
                //   { required: true, message: "请输入采购单号", trigger: "blur" }
                // ],
                demandAmount: [
                    { required: true, validator: validatePass, trigger: "blur" }
                    // { type:'number',, trigger: "blur" },
                ]
            },
            // 导入显示数据
            exportInfo: {
                success: 0,
                fail: 0,
                url: null,
                total: 20
            },
            // 导入对话框
            exportDialogVisible: false,
            permission: JSON.parse(localStorage.getItem("permission"))
        };
    },
    created: function () {
        this.getMlist();
    },
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? (this.W = true) : (this.W = false);
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? (this.W = true) : (this.W = false);
        };
        // 数据初始化
        this.init();
    },
    methods: {
		cancelEdit(){
			this.editDialogVisible = false
			this.getMlist()
		},
		cancelAdd(){
			this.addDialogVisible = false;
			this.getMlist()
		},
        // 状态
        parseStatus: function (row) {
            if (row.purchaseStatus == 0) {
                return "未审核";
            } else if (row.purchaseStatus == 1) {
                return "已审核";
            } else if (row.purchaseStatus == 2) {
                return "已完成";
            } else if (row.purchaseStatus == 3) {
                return "已取消";
            } else {
                return "";
            }
        },
     
        // 获取类型数据
        changeType(value) {
            log(value);
            this.purchaseType = value;
        },
        // 初始化
        init: function () {
            this.search();
        },
        uploadUrl() {
            return `/api/purchase/importPurchase?token=${localStorage.getItem("token")}`;
        },
        // 导入
        beforeLoad(file) {
            let fileSize = file.size / 1024 / 1024;
            fileSize = Math.round(fileSize * 100) / 100;
            if (fileSize >= 5) {
                this.$message({
                    type: "error",
                    message: `文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
                });
                return false;
            }
            this.$RequestUtil.loading();
        },

        materSelect(ev){
            let {materialCode,materialName} = this.materiaList.find(item=>item.id==ev)||{materialCode:'',materialName:''}
            this.addForm.materialName = materialName
            this.addForm.materialCode = materialCode
        },
        
        uploadComplete: function (response, file, fileList) {
            this.$RequestUtil.loading().close();
            if (response != null) {
                if (response.code == 0) {
                    this.exportInfo.url = response.data.url;
                    this.exportInfo.success = response.data.success;
                    this.exportInfo.fail = response.data.fail;
                    this.exportInfo.total = Number(response.data.fail) + Number(response.data.success);
                    this.exportDialogVisible = true;
                    // this.$store.commit("add_reloadPages", ['/WorkShop', '/MasterData/UserMgt']);
                    this.init();
                } else if (response.code == -1) {
                    this.$message({
                        type: "error",
                        message: response.msg
                    });
                } else if (response.code == 10) {
                    this.$message({
                        type: "error",
                        message: "登入过期！"
                    });
                    this.$router.push({ path: "/Login", name: "Login" });
                    return;
                }
            }
        },
        // 重置表单
        clearSearch() {
            this.searchForm.purchaseCode = ""
            this.searchForm.materialId = null
            this.searchForm.PurchaseType = null
            this.search(1)
        },
        // 打开编辑框
        editBtn(rowData) {
            this.editAddForm = CommonUtils.cloneObj(rowData);
            this.editDialogVisible = true;
        },
        // 提交编辑
        submitAddDialog() {
            this.$refs["editForm"].validate(valid => {
                log(valid);
                if (valid) {
                    this.$RequestUtil.post({
                        url: "/api/purchase/updatePurchase",
                        type: "sync",
                        params: {
                            // materialId:this.editAddForm.materialId,
                            purchaseId: this.editAddForm.purchaseId,
                            purchaseType: this.editAddForm.purchaseType,
                            demandAmount: this.editAddForm.demandAmount,
                            planPurchaseTime: this.editAddForm.planPurchaseTime,
                            purchaseDetailId: this.editAddForm.purchaseDetailId,
                            supplier: this.editAddForm.supplier
                        },
                        success: res => {
                            if (res.code == 0) {
                                this.search(this.page.currentPage);
								this.$message.success("编辑成功");
								this.editDialogVisible = false;
								this.getMlist()
                            } else {
                                log(res.code);
                                log(res.message);
                                this.$message.error(res.msg||res.message);
                            }
                        }
                    });
                } else {
                    this.$message.error("请输入正确信息");
                }
                // this.search(this.page.currentPage);
                
            });
        },
        // 新增采购单
        addOrdrList() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: "/api/purchase/addPurchase",
                        type: "sync",
                        params: {
                            // 采购类型
                            purchaseType: this.addForm.purchaseType,
                            materialName:this.addForm.materialName,
                            materialCode:this.addForm.materialCode, 
                            // 物料id
                            materialId: this.addForm.materialId,
                            // 预计到场时间
                            planPurchaseTime: this.addForm.planPurchaseTime,
                            // 需求数量
                            demandAmount: this.addForm.demandAmount,
                            supplier:this.addForm.supplier
                        },
                        success: res => {
                            if (res.code == 0) {
                                this.$message.success("添加成功");
                                this.search(this.page.currentPage);
                                this.addDialogVisible = false;
                                
								this.getMlist()
                            } else {
                                this.$message.error(res.msg||res.message);
                            }
                        }
                    });
                } else {
                    this.$message.warning("请输入正确信息！");
                }
            });
            
        },
        changeDate(value) {
            this.editAddForm.planPurchaseTime = value;
        },
        //
        remoteMethod: async function (code,name) {
            this.loading = true
            await this.getMlist(code,name)
            this.loading = false
            
        },
          selectBlur(ev){
           
            if(ev){
                this.remoteMethod()
            }
        },
        //
        pageChange(pageNum) {
            this.search(pageNum);
            this.page.currentPage = pageNum;
            log(this.page.pageNum);
        },
        // 新增采购单
        addOrder() {
            this.addDialogVisible = true;
            this.addForm.purchaseType = 1
            //
            this.getMlist();
        },
        // 关闭新增重置表单
        resetForm: function (addForm) {
            // log(this.$refs)
            this.$refs.addForm.resetFields()
            this.addForm.purchaseType = ""
            this.addForm.public = ""
            this.addForm.planPurchaseTime = ""
            this.addForm.supplier = ''
            this.addForm.materialId = null
        },
        clickSearch: function (paage, type) {
            if (type) {
                this.$set(this.page, "tableCurrentPage", 1);
            }
            this.search(1);
        },
       
        // 搜索
        search: function (pageNum) {
            log(this.searchForm)
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            this.$set(this.page, "tableCurrentPage", pageNum);
            this.$RequestUtil.get({
                url: "/api/purchase/listPurchase",
                type: "sync",
                params: {
                    // 采购类型
                    PurchaseType: this.searchForm.PurchaseType,
                    // 当前页
                    pageNum: pageNum,
                    // 页/条
                    pageSize: this.page.pageSize,
                   
                    // 采购单号
                    purchaseCode: this.searchForm.purchaseCode,
                    materialId: this.searchForm.materialId
                },
                success: res => {
                    if (res.code == 0) {
                        log(res);
                        this.purchaseList = res.data;
                        this.page.total = res.totalPages;
                        if (res.totalPages == 0) {
                            this.$message.warning("查询不到符合条件的数据");
                        }
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
        },
        // 审核
        dispose(rewData, purchaseStatus) {
            log(rewData.purchaseId, purchaseStatus);
            if (purchaseStatus == 0) {
                purchaseStatus = 1;
                log(purchaseStatus);
            } else if (purchaseStatus == 1) {
                purchaseStatus = 0;
            }
            log(purchaseStatus);
            this.$confirm("确定审核该数据?", "提示", {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$RequestUtil.post({
                    url: "/api/purchase/updatePurchase",
                    type: "sync",
                    params: {
                        purchaseId: rewData.purchaseId,
                        purchaseStatus
                    },
                    success: res => {
                        if (res.code == 0) {
                            this.$message.success("审核成功");
                            // this.initTable();
                            // this.cancelAddDialog();
                            this.search(this.page.currentPage);
                        } else {
                            log(res.message);
                            this.$message.error(res.msg||res.message);
                        }
                    }
                });
            });
        },
        // 反审核
        dispose1(rewData, purchaseStatus) {
            log(rewData.purchaseId, purchaseStatus);
            if (purchaseStatus == 0) {
                purchaseStatus = 1;
                log(purchaseStatus);
            } else if (purchaseStatus == 1) {
                purchaseStatus = 0;
            }
            log(purchaseStatus);
            this.$confirm("确定反审核该数据?", "提示", {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$RequestUtil.post({
                    url: "/api/purchase/updatePurchase",
                    type: "sync",
                    params: {
                        purchaseId: rewData.purchaseId,
                        purchaseStatus
                    },
                    success: res => {
                        if (res.code == 0) {
                            this.$message.success("反审核成功");
                            this.search(this.page.currentPage);
                        } else {
                            log(res.message);
                            this.$message.error(res.msg||res.message);
                        }
                    }
                });
            });
        },
        // 取消
        dispose2(rewData, purchaseStatus) {
            log(rewData.purchaseId, purchaseStatus);
            if (purchaseStatus == 0) {
                purchaseStatus = 1;
                log(purchaseStatus);
            } else if (purchaseStatus == 1) {
                purchaseStatus = 0;
            }
            log(purchaseStatus);
            this.$confirm("确定取消该数据?", "提示", {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$RequestUtil.post({
                    url: "/api/purchase/updatePurchase",
                    type: "sync",
                    params: {
                        purchaseId: rewData.purchaseId,
                        purchaseStatus
                    },
                    success: res => {
                        if (res.code == 0) {
                            this.$message.success("取消成功");
                            this.search(this.page.currentPage);
                        } else {
                            log(res.message);
                            this.$message.error(res.msg||res.message);
                        }
                    }
                });
            });
        },
        // 完成
        dispose3(rewData, purchaseStatus) {
            log(rewData.purchaseId, purchaseStatus);
            if (purchaseStatus == 0) {
                purchaseStatus = 1;
                log(purchaseStatus);
            } else if (purchaseStatus == 1) {
                purchaseStatus = 0;
            }
            log(purchaseStatus);
            this.$confirm("确定完成该数据?", "提示", {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$RequestUtil.post({
                    url: "/api/purchase/updatePurchase",
                    type: "sync",
                    params: {
                        purchaseId: rewData.purchaseId,
                        purchaseStatus
                    },
                    success: res => {
                        if (res.code == 0) {
                            this.$message.success("已完成");
                            this.search(this.page.currentPage);
                        } else {
                            log(res.message);
                            this.$message.error(res.msg||res.message);
                        }
                    }
                });
            });
        },
        // 改变时间
        check(ev, type) {
            log(new Date(ev).getTime())
            if (type == 1) {
                if (new Date(ev).getTime() < new Date().getTime() - 86400000) {
                    this.$message.warning(
                        "预计到厂时间不能小于当前时间,请重新选择时间"
                    );
                    this.editAddForm.planPurchaseTime = null;
                    this.addForm.planPurchaseTime = null;
                }
            }
        },

        // 获取物料名称下拉选项
        async getMlist(materialCode,materialName) {
            let res = await this.$RequestUtil.getAsync({
                url: "/api/select/listMaterial",
                params: {
                    materialCode,
                    materialName,
                    productionType:4
                }
            });
            if (res.code != 0) {
                this.$message.error(res.msg || res.message);
                return;
            }
            this.materiaList = res.data;
        },

      
        // 打印btn
        printList(data) {
            // 将数据保存在localStorage中，并定义新的字段名printPurchase
            data.purchaseStatusName = this.parseStatus(data)
            localStorage.setItem("printPurchase", JSON.stringify(data));
            let routeUrl = this.$router.resolve({ path: "/Print/PrintPurchase" });
            window.open(routeUrl.href, "_blank");
        }
    }
};
</script>

<style scoped>
/* #Purchase_order .title {
    font-size: 14px;
} */

.value {
    font-size: 16px;
    color: #999;
    font-family: NotoSansHans-Regula;

    line-height: 3;
}
.confirm_btn {
    text-align: center;
}
.import_upload {
    display: inline;
}
.import_upload > .el-upload-list {
    display: none;
}
@media screen and (max-width: 1380px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}
/* 分页 */
.total_page {
    margin-top: 16px;
    margin-right: 16px;
    color: #606266;
    font-size: 14px;
}
.page {
    display: flex;
    justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/order/PurchaseCenter.vue